module.exports = __webpack_public_path__ + "img/user.a82bb325.svg";